import { BadgeDefinition } from '../types/badge'

export const BADGES: BadgeDefinition[] = [
  {
    id: 'subject-0001',
    imageSrc: '/SUBJECT%200001%20BADGE%20EARLY%20ACCESS%20TRANSPARENT.png',
    imageAlt: 'Subject 0001 — Early Access Badge',
    eyebrow: 'Classified dossier · Early access',
    title: 'Subject 0001',
    subtitle: 'Codename: Broken Record',
    lead:
      'Operates on gut-feel RNG. Thinks in loops. Forgets why it entered the shop. Still shows up anyway.',
    body: [
      'Subject 0001 was catalogued after repeatedly posting strings at 3:12 AM with zero milk and maximum honesty. Field researchers note high charisma when vulnerable, suspicious resistance to finishing poems about mothers.',
    ],
    footnote:
      'Weakness: reflective surfaces. Strength: making strangers feel seen then immediately ghosting their DMs.',
    statusEffects: [
      { label: '+10 HP', tone: 'text-emerald-300' },
      { label: '+3 VIBE', tone: 'text-sky-300' },
      { label: 'LOOP IMMUNITY', tone: 'text-violet-300' },
      { label: '-2 SLEEP', tone: 'text-rose-300' },
      { label: 'MILK QUEST FAILED', tone: 'text-amber-300' },
      { label: 'ECHO RESONANCE', tone: 'text-cyan-300' },
    ],
  },
]

export function getBadgeById(id: string): BadgeDefinition | undefined {
  return BADGES.find((b) => b.id === id)
}

/** Badge shown on the default profile header */
export const PROFILE_BADGE_ID = 'subject-0001'
